import { mainSiteUrl } from '@/data/categories';

export default function WhatIsSection() {
  return (
    <section id="what-is" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100/70 text-primary-700 text-xs font-semibold mb-3">
            Podstawy
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            Czym jest Kakobuy Spreadsheet?
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-3xl mx-auto">
            Kakobuy Spreadsheet to uporządkowana baza produktów zawierająca linki, ceny, kategorie oraz
            informacje pomagające użytkownikom z Polski znaleźć najlepsze oferty na chińskich platformach
            zakupowych. To kompletne narzędzie, które eliminuje konieczność samodzielnego przeszukiwania
            tysięcy aukcji – wszystko masz w jednym, regularnie aktualizowanym arkuszu.
          </p>
        </div>

        <div className="max-w-3xl mx-auto overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="border-b-2 border-background-200">
                <th className="text-left py-4 px-4 md:px-6 text-sm font-semibold text-foreground-800">Metoda</th>
                <th className="text-left py-4 px-4 md:px-6 text-sm font-semibold text-foreground-800">Czas wyszukiwania</th>
                <th className="text-left py-4 px-4 md:px-6 text-sm font-semibold text-foreground-800">Ilość produktów</th>
                <th className="text-left py-4 px-4 md:px-6 text-sm font-semibold text-foreground-800">Łatwość użycia</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-background-200/70 bg-primary-50/30">
                <td className="py-4 px-4 md:px-6">
                  <div className="flex items-center gap-2">
                    <span className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                      <i className="ri-star-fill text-white text-xs"></i>
                    </span>
                    <span className="font-semibold text-foreground-900 text-sm">Kakobuy Spreadsheet</span>
                  </div>
                </td>
                <td className="py-4 px-4 md:px-6">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-semibold">
                    <i className="ri-flashlight-line"></i>
                    Szybki
                  </span>
                </td>
                <td className="py-4 px-4 md:px-6">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-semibold">
                    <i className="ri-stack-line"></i>
                    Bardzo duża
                  </span>
                </td>
                <td className="py-4 px-4 md:px-6">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-semibold">
                    <i className="ri-emotion-happy-line"></i>
                    Łatwa
                  </span>
                </td>
              </tr>
              <tr className="border-b border-background-200/70">
                <td className="py-4 px-4 md:px-6">
                  <div className="flex items-center gap-2">
                    <span className="w-8 h-8 rounded-lg bg-secondary-200 flex items-center justify-center">
                      <i className="ri-search-line text-secondary-600 text-xs"></i>
                    </span>
                    <span className="font-medium text-foreground-700 text-sm">Samodzielne szukanie</span>
                  </div>
                </td>
                <td className="py-4 px-4 md:px-6">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-100/80 text-secondary-700 text-xs font-semibold">
                    <i className="ri-time-line"></i>
                    Wolny
                  </span>
                </td>
                <td className="py-4 px-4 md:px-6">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-100/80 text-secondary-700 text-xs font-semibold">
                    <i className="ri-file-list-line"></i>
                    Średnia
                  </span>
                </td>
                <td className="py-4 px-4 md:px-6">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-100/80 text-secondary-700 text-xs font-semibold">
                    <i className="ri-emotion-unhappy-line"></i>
                    Trudna
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="text-center mt-8">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white font-semibold text-sm rounded-full hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
          >
            Kakobuy Spreadsheet
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}